/* eslint-disable no-unused-vars */
import { makeStyles } from "@mui/styles";
import styles from "../../assets/jss/material-dashboard-react/views/dashboardStyle.js";
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useTranslation } from "react-i18next";
import API from "../../utils/API";
import _ from "lodash";

const useStyles = makeStyles(styles);

export default function SalesDeptWise() {
  const { t } = useTranslation();
  const translate = t;
  const classes = useStyles();
  const [options, setOptions] = useState({});
  const [series, setSeries] = useState([]);

  useEffect(() => {
    loadDataFromServer();
  }, []);

  async function loadDataFromServer() {
    try {
      const { data } = await API.post("/report/analytics", {
        template: "reports/analytics/dashboard/stock_by_dept",
      });
      console.log(data);
      let config = {
        chart: {
          type: "donut",
        },
        labels: data.labels,
        title: {
          text: "Stock By Department",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      };
      setOptions(config);
      setSeries(data.series);
    } catch (e) {
      console.error(e);
    }
  }

  return (
    <div id="chart">
      <ReactApexChart
        options={options}
        series={series}
        type="donut"
        height={220 + _.random(0, 1, true)}
      />
    </div>
  );
}
